import { render, staticRenderFns } from "./advanced-properties-modal.vue?vue&type=template&id=b3bf2868&scoped=true"
import script from "./advanced-properties-modal.vue?vue&type=script&lang=js"
export * from "./advanced-properties-modal.vue?vue&type=script&lang=js"
import style0 from "./advanced-properties-modal.vue?vue&type=style&index=0&id=b3bf2868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bf2868",
  null
  
)

export default component.exports